import { gql } from '@apollo/client'
import cartProductsFieldsQuery from '../../commons/fields/cartProducts'

/**
 * gets the string for `prefillCart` query
 * gets all the products to prefill cart based on ML suggestions
 *
 * `$limit` must be passed to the field, not only declared: `HttpLink` strips
 * every variable the document does not use outside its definitions
 * (`filterOperationVariables`), so a declared-but-unused `$limit` never
 * reaches the server. An omitted `$limit` lets the resolver pick its default.
 * @internal
 */

const prefillCartQuery = gql`
  query PrefillCart(
    $storefrontName: String!, 
    $sessionUid: String!,
    $limit: Int
  ) {
    prefillCart(storefrontName: $storefrontName, sessionUid: $sessionUid, limit: $limit) {
      ${cartProductsFieldsQuery}
    }
  }
`

export default prefillCartQuery
